export enum RegistrationEvent {
  PhoneNumberConfirmed = "PhoneNumberConfirmed",
  PinCodeVerified = "PinCodeVerified",
  SponsorshipConfirmed = "SponsorshipConfirmed",
  OnlineCodesVerified = "OnlineCodesVerified",
  PersonalInfoSubmitted = "PersonalInfoSubmitted",
  GoldStandardAccepted = "GoldStandardAccepted",
  AgreementsAccepted = "AgreementsAccepted",
  PaymentStarted = "PaymentStarted",
  PaymentDone = "PaymentDone",
  RegistrationCompleted = "RegistrationCompleted",
  PersonalInfoSubmissionFailed = "PersonalInfoSubmissionFailed",
}
